import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Button,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';

import FeedbackManagerRenderer from './FeedbackManagerRenderer';
import SurveyManagerRenderer from './SurveyManagerRenderer';
import styles from './styles.css';

class ModalDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opportunity: null,
    };
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const newOpportunity = nextProps.opportunity || {};
    const currentOpportunity = this.props.opportunity || {};
    if (newOpportunity.opportunity_id && newOpportunity.opportunity_id !== currentOpportunity.opportunity_id) {
      this.setState({ opportunity: nextProps.opportunity });
    }
  }

  handleClose() {
    console.log('closeeee');
    this.props.onClose();
  }

  renderRequestFeedbackBtn() {
    const { mode } = this.props;
    if (mode === 'surveys') {
      return (
        <Button
          className="pull-left"
          bsStyle="primary"
          onClick={() => {
            this.props.requestAddOpportunitySurvey(this.props.opportunity);
          }}
        >
          <Fa name="plus" /> Request Feedback
        </Button>
      );
    }
    return null;
  }
  render() {
    const { opportunity } = this.state;
    const { mode } = this.props;
    const show = this.props.opportunity && this.props.opportunity.opportunity_id !== undefined;
    const name = opportunity ? opportunity.name : null;
    const hasContent = opportunity !== null && opportunity !== undefined;
    const props = {};
    if (hasContent) {
      props.data = opportunity;
      props.requestShowInsight = this.props.requestShowInsight;
      props.requestAddOpportunitySurvey = this.props.requestAddOpportunitySurvey;
      props.requestShowEmail = this.props.requestShowEmail;
    }
    let title = null;
    if (mode === 'feedbacks') {
      title = 'Outcome Reasons: ';
    } else if (mode === 'surveys') {
      title = 'Feedback Requests: ';
    }

    return (
      <Modal
        bsSize="lg"
        show={show}
        onHide={this.handleClose}
        className={styles.detailModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title} {name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasContent &&
            <div>
              {mode === 'feedbacks' && <FeedbackManagerRenderer {...props} />}
              {mode === 'surveys' && <SurveyManagerRenderer {...props} />}
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            {this.renderRequestFeedbackBtn()}
            <Button className="pull-right" bsStyle="link" onClick={this.handleClose}>Done</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalDetail.propTypes = {
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
  }),
  mode: PropTypes.string,
  requestShowInsight: PropTypes.func,
  requestAddOpportunitySurvey: PropTypes.func,
  requestShowEmail: PropTypes.func,
  onClose: PropTypes.func,
};
ModalDetail.defaultProps = {
  opportunity: null,
  requestShowInsight: () => {},
  mode: null,
  requestAddOpportunitySurvey: () => {},
  requestShowEmail: () => {},
  onClose: () => {},
};

export default ModalDetail;
